export default __webpack_public_path__ + "static/media/canje.ab6c3eab.png";